import { useState } from "react";
import ConfirmModal from "./ConfirmModal";
import { deleteDeliveryLocation } from "../../utils/zulalWebAPI";
import { encryptDataBase64 } from "../../utils/encryptionUtils";
import toast from "react-hot-toast";
import generateSecretKey from "../../utils/keyGenerationUtils";

const AddressCard1 = ({ address, onEdit, refreshList, totalLocations }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState(null);

  // Called when "Remove" is clicked
  const confirmDelete = (locationId) => {
    setSelectedLocationId(locationId);
    setIsModalOpen(true);
  };

  // function to remove the delivery location
  const handleDelete = async () => {
    // Restrict deletion if total locations are 1

    if (totalLocations === 1) {
      toast.error("You cannot delete the last address");
      return;
    }

    const secretKey = generateSecretKey();
    //console.log(secretKey);

    const encryptedCustomerInfo = encryptDataBase64(
      selectedLocationId,
      secretKey
    );

    const encryptedData = {
      secretKey: secretKey,
      encrypteCustomerInfo: encryptedCustomerInfo,
    };

    // Call delete API
    const response = await deleteDeliveryLocation(encryptedData);
    console.log(response);

    if (response.status === "success") {
      toast.success("Address deleted successfully");
      refreshList(); // Trigger re-fetching of addresses
    } else {
      toast.error("Error deleting address");
    }
  };

  return (
    <div className="border border-secondary rounded-md shadow-lg p-4 bg-primaryVeryLight">
      <div className="text-sm text-gray-500 mb-2">
        <div class="flex items-start gap-x-3">
          {address.isDefault && (
            <p class="mt-0.5 rounded-full bg-green-100 px-1.5 py-0.5 text-C11 font-semibold whitespace-nowrap text-green-700 ring-1 ring-green-600/20 ring-inset">
              {address.isDefault ? "Default" : ""}
            </p>
          )}
          <p class="text-sm/6 font-semibold text-gray-900 uppercase">
            {address.locationLabel}
          </p>
        </div>
      </div>
      <div>
        <hr className="mb-1" />
      </div>
      <div className="text-sm text-gray-800 leading-6">
        <p className="font-poppins text-base">{address.RecipientName}</p>
        <p>
          {address.flatNumber}, {address.buildingName},{" "}
          {`${address.areaName}(${address.areaCode})`},<p>{address.Landmark}</p>
          {`${address.statessName}(${address.stateCode})`}, <br />
        </p>
        <p className="font-poppins text-C12">Contact: {address.phoneNumber}</p>
      </div>
      <div className="mt-4 text-sm text-blue-600 space-x-2">
        <button
          onClick={() => onEdit(address)}
          className="mt-2 bg-yellow-500 text-white px-3 py-1 rounded"
        >
          Edit
        </button>
        <span>|</span>
        <button
          className="hover:underline"
          onClick={() => confirmDelete(address.locationId)}
        >
          Remove
        </button>
      </div>
      <ConfirmModal
        isOpen={isModalOpen}
        onConfirm={handleDelete}
        onCancel={() => setIsModalOpen(false)}
        message="Do you want to delete this address?"
      />
    </div>
  );
};

export default AddressCard1;

// CREATE TABLE [dbo].[DeliveryLocations] (
//   [LocationId]    INT            IDENTITY (1, 1) NOT NULL,
//   [CustomerCode]  NVARCHAR (50)  NULL,
//   [LocationLabel] NVARCHAR (100) NULL,
//   [RecipientName] NVARCHAR (100) NULL,
//   [Phone]         NVARCHAR (20)  NULL,
//   [BuildingName]  NVARCHAR (255) NULL,
//   [FlatNumber]    NVARCHAR (255) NULL,
//   [Landmark]      NVARCHAR (255) NULL,
//   [CountryId]     INT            NULL,
//   [CountryName]   NVARCHAR (10)  NULL,
//   [StateId]       INT            NULL,
//   [StateCode]     NVARCHAR (10)  NULL,
//   [StateName]     NVARCHAR (100) NULL,
//   [CityId]        INT            NULL,
//   [CityCode]      NVARCHAR (10)  NULL,
//   [CityName]      NVARCHAR (150) NULL,
//   [AreaId]        INT            NULL,
//   [AreaCode]      NVARCHAR (10)  NULL,
//   [AreaName]      NVARCHAR (255) NULL,
//   [StreetCode]    NVARCHAR (10)  NULL,
//   [StreetName]    NVARCHAR (255) NULL,
//   [IsDefault]     BIT            DEFAULT ((0)) NULL,
//   PRIMARY KEY CLUSTERED ([LocationId] ASC)
// );
